import { useQuery } from "@apollo/client";
import { Box, Divider, Flex, VStack} from "@chakra-ui/react";
import { TitleLink } from "../TitleLink";
import {
  GET_REVIEWED_URL,

} from "../../../graphql/operations/campaignOperations/operations";
import { ComponentLoading } from "../../../components/loading/ComponentLoading";
import { Navigate, useParams } from "react-router-dom";
import { decodeURL } from "../../../utils/encodeUrl";
import { useHitlFilters } from "..";
import {
  GET_PREDICTED_URLS,
} from "../../../graphqlExternal/operations/operations";
import { PredictedUrlsList } from "../predictiveCorrections/predictedUrlsList"


export const PredictiveCorrection = () => {
  const hitlFilters = useHitlFilters();
  const predictedFromUrl = decodeURL(useParams().url || "");
  
  // find similar urls
  const {
    data: similarData,
    error: similarError,
    loading: similarLoading,
  } = useQuery(GET_PREDICTED_URLS, {
    variables: {
      publisher: hitlFilters.publisherFilter.value,
      url: predictedFromUrl,
      matchThreshold: 0.81,
    },
    context: { clientName: "illumaDbEndpoint", type: "graphql" },

  });

  

  // get corrected data from predicted from url
  const {
    data: correctedData,
    error: correctedError,
    loading: correctedLoading,
  } = useQuery(GET_REVIEWED_URL, {
    variables: {
      url: predictedFromUrl,
    },
    fetchPolicy: "cache-and-network",
  });

  if (similarLoading || correctedLoading ) {
    return <ComponentLoading text={"Loading..."} />;
  }

  if (!predictedFromUrl || correctedError || similarError || !correctedData.reviewedUrl ) {
    return <> Error </>;
  }

  if (!similarData) {
    return <Navigate to={"/human-in-the-loop"} />;
  }

  const predictedUrls: string[] = similarData.predictedUrlsList.urls;

  let acceptedClassification: Record<string, string[]>
  let rejectedClassification: Record<string, string[]>

  try {

    acceptedClassification = JSON.parse(correctedData.reviewedUrl.reviewedClassification)

    for (const key in acceptedClassification) {
      if (key.includes("illuma_ents")) {
          delete acceptedClassification[key]
      } 
    }

    rejectedClassification = JSON.parse(correctedData.reviewedUrl.rejectedClassification)

    for (const key in rejectedClassification) {
      if (key.includes("illuma_ents")) {
          delete rejectedClassification[key]
      } 
    }

  } catch(err) {
    return <>Error retrieving corrected data</>

  }
  

  return (
    <Box mx={1} my={6} justify={"flex-end"}>
      <Flex
        bgColor={"white"}
        borderRadius={"lg"}
        p={4}
        mb={10}
        direction={"column"}
      >
        <TitleLink showNote={false} url={predictedFromUrl} showLink={true} />

        <VStack alignItems={"stretch"} spacing={4} justify={"flex-end"}>
          {/* map over data to get each predicited url and its values */}

          {Object.entries(predictedUrls).map((url, iw) => (
            <div key={iw}>

            <PredictedUrlsList 
            classificationData={JSON.stringify(acceptedClassification)}
            rejectedClassificationData={JSON.stringify(rejectedClassification)}
            url={String(url[1])}
            predictedFromUrl={predictedFromUrl}
            />
            </div>
          ))}

          <Divider borderColor={"muted"} />
        </VStack>
      </Flex>
    </Box>
  );
};





